module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"staff_review":"Admin review","my_review":"My Review"}}')
  delete Component.options._Ctor
}
